// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1lJk3","text":"styles_text__-JDjt","btns":"styles_btns__3JR_g"};